import HostedDesktopLayout from '../../../layouts/DesktopLayout';
import HostedAbortScreen from '../shared/AbortScreen';
import { type AbortPageProps } from '../../../chulak/ChulakSession';

export default function HostedDesktopAbortPage(props: AbortPageProps) {
  return (
    <HostedDesktopLayout>
      <HostedAbortScreen {...props} buttonDirection="row" />
    </HostedDesktopLayout>
  );
}
